import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchGlobalProducts } from "../../Redux/globalProductsSlice";
import { useNavigate } from "react-router-dom";

import Loading from "../../components/Loading";
import bannerGif from "../../Assests/Banner.gif";
import NoProductsAvailable from "../../components/NoProductsAvailable";


const GlobalStore = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { items, loading, error } = useSelector((state) => state.globalProducts);
  const products = items?.results || [];

  useEffect(() => {
    dispatch(fetchGlobalProducts());
  }, [dispatch]);


  if (loading) return <Loading />;

  if (error) return <p>Error loading products: {error}</p>;

  return (
    <div style={{ padding: "16px" }}>
      {/* <h2>Global Store Products</h2> */}

      {products.length === 0 ? (
        <NoProductsAvailable />
      ) : (
        <>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: "30px",
              padding: "0 40px",
              justifyContent: "space-around"
            }}
          >
            {products.map((item, idx) => {
              const title = item.title || item.name || "No title";
              const baseImageUrl = "https://luckywheel-staging-bucket.s3.amazonaws.com/Tagon_Products/image/";
              const imagePath = item.inventory?.[0]?.images?.[0]?.img;
              const imageUrl = imagePath?.startsWith("http")
                ? imagePath
                : imagePath
                  ? baseImageUrl + imagePath
                  : "https://dummyimage.com/300x300/cccccc/ffffff&text=No+Image";

              const price = item.price || item.inventory?.[0]?.size_and_price?.[0]?.product_price;

              return (
                <div
                  key={idx}
                  onClick={() => navigate(`/products/${item.id}`)}
                  style={{
                    padding: "12px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    transition: "transform 0.2s",
                  }}
                >
                  <img
                    src={imageUrl}
                    alt={title}
                    style={{
                      width: '100%',
                      height: '400px', // Fixed height
                      objectFit: 'contain', // Prevents stretching
                      objectPosition: 'center',

                      borderRadius: '6px',
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://dummyimage.com/300x300/cccccc/ffffff&text=No+Image";
                    }}
                  />
                  <div style={{ marginTop: "8px" }}>
                    {/* <p style={{ fontSize: "12px", color: "gray", marginBottom: "4px" }}>
                      FEW ITEMS LEFT
                    </p> */}
                    <p style={{ fontWeight: "500", fontSize: "14px", marginBottom: "6px" }}>
                      {title}
                    </p>
                    <p style={{ fontWeight: "600", fontSize: "15px", marginBottom: "2px" }}>
                      ₹{price}
                    </p>
                    <p style={{ fontSize: "11px", color: "gray" }}>
                      MRP incl. of all taxes
                    </p>
                  </div>
                </div>
              );
            })}
          </div>


          <div
            style={{
              width: "100%",
              margin: "60px 0",
              padding: "0 40px",
            }}
          >
            <img
              src={bannerGif}
              alt="Fashion Trends GIF"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "12px",
                objectFit: "cover",
              }}
            />

          </div>
        </>
      )}
    </div>
  );
};

export default GlobalStore;

